import emailjs from '@emailjs/browser';

// Get environment variables with fallback
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

// Debug logging
console.log('EmailJS Environment Variables:', {
  hasPublicKey: !!PUBLIC_KEY,
  hasServiceId: !!SERVICE_ID,
  hasTemplateId: !!TEMPLATE_ID,
  publicKey: PUBLIC_KEY ? `${PUBLIC_KEY.substring(0, 8)}...` : 'undefined',
  serviceId: SERVICE_ID,
  templateId: TEMPLATE_ID
});

if (!PUBLIC_KEY) {
  console.error('EmailJS public key missing. Set REACT_APP_EMAILJS_PUBLIC_KEY in .env.local');
}

if (!SERVICE_ID) {
  console.error('EmailJS service ID missing. Set REACT_APP_EMAILJS_SERVICE_ID in .env.local');
}

if (!TEMPLATE_ID) {
  console.error('EmailJS template ID missing. Set REACT_APP_EMAILJS_TEMPLATE_ID in .env.local');
}

// Initialize EmailJS
if (PUBLIC_KEY) {
  emailjs.init({ publicKey: PUBLIC_KEY });
}

export const sendContactEmail = async (templateParams) => {
  if (!PUBLIC_KEY || !SERVICE_ID || !TEMPLATE_ID) {
    throw new Error('EmailJS configuration incomplete. Check environment variables.');
  }

  try {
    const result = await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams);
    return result;
  } catch (error) {
    console.error('EmailJS send error:', error);
    throw error;
  }
};
